interface RouteObject {
  path: string;
  base?: string;
}

export const RouteMap: { [id: string]: RouteObject } = {
  HOME: {
    path: '/',
  },
  CONTENT_HUB_LANDING: {
    path: '/learn',
  },
  TOPICS: {
    path: '/learn/[...contentHubSlugs]',
    base: '/learn',
  },
  GENERIC: {
    path: '/[slug]',
  },
  SHOWCASE: {
    path: '/showcase/[slug]',
    base: '/showcase',
  },
  AUTHOR: {
    path: '/writers/[slug]',
    base: '/writers',
  },
  BUSINESS_ONBOARDING: {
    path: '/get-started',
  },
  CAMPAIGNS: {
    path: '/campaigns/[slug]',
    base: '/campaigns',
  },
  MARKETING: {
    path: '/benefits',
  },
  ARTICLE: {
    path: '/learn/[...contentHubSlugs]',
    base: '/learn',
  },
  SYMPTOM_CHECKER: {
    path: '/symptom-checker',
  },
  SIGN_UP: {
    path: '/signup',
  },
  SIGN_IN: {
    path: '/login',
  },
};

export const RoutesWithoutPageHeroButton = [
  `${RouteMap.SHOWCASE.base}/`,
  `${RouteMap.TOPICS.base}/`,
  `${RouteMap.ARTICLE.base}/`,
];

export const RoutesWithoutFooter = [
  RouteMap.BUSINESS_ONBOARDING.path,
  `${RouteMap.CAMPAIGNS.base}/`,
];

export const RoutesWithMinimalNav = [`${RouteMap.SHOWCASE.base}/`];
